export default __webpack_public_path__ + "static/media/orangearrow.d8a3796d.svg";